module.exports = __webpack_public_path__ + "static/media/announcenew.6da45963.svg";